module.exports = __webpack_public_path__ + "img/SA.943cf626.svg";